import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=0acb2696"
import script from "./Parent.vue?vue&type=script&lang=js"
export * from "./Parent.vue?vue&type=script&lang=js"
import style0 from "./Parent.vue?vue&type=style&index=0&id=0acb2696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports